export default __webpack_public_path__ + "static/media/life.836c6a7f.webp";